import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { canDeactivateWithModal } from '@shared/functions/can-deactivate-with-modal.function';
import {
  selectSecurityEventsHasChanges,
  selectSecurityEventsItem,
  selectSecurityEventsProtocolSaving,
} from '../state/security-events.selectors';

export const securityEventProtocolCanDeactivate: CanDeactivateFn<unknown> = (
  _component,
  route,
) => {
  const store = inject(Store);
  const protocolMode =
    store.selectSignal(selectSecurityEventsItem)()?.responseProcessMode ===
    'PROTOCOL';
  const infoChild = route.routeConfig?.path === '';
  if (infoChild && !protocolMode) return true;
  // The info child checks the same draft once when leaving the whole card.
  if (
    protocolMode &&
    !infoChild &&
    route.children.some((child) => child.routeConfig?.path === '')
  )
    return true;
  if (store.selectSignal(selectSecurityEventsProtocolSaving)()) return false;
  return canDeactivateWithModal([store.select(selectSecurityEventsHasChanges)]);
};
